import {DumpsterFire} from "../DumpsterFire";
import {TimelineLite} from "gsap";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";

export class DFTransitionView extends PIXI.Container implements StageLayer {
    constructor() {
        super();
        this.name = "DFTransitionView";
    }

    public playTransitionAnim(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (DumpsterFire.model.data.upgradedSymbols.length > 0) {
            const anim: PIXI.spine.Spine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("featherTransition"));
            anim.visible = true;
            anim.position.set(360);
            tl.add([
                () => {
                    this.addChild(anim);
                    DumpsterFire.soundPlayer.playSound(DumpsterFireSound.TRANSITION_SCREEN);
                },
                DumpsterFire.createTimelineForAnimation(anim, 0, "animation", false)
            ], 0);
        }
        return tl;
    }

    public removeTransitionAnim(): void {
        this.removeChildren();
    }
}